import React from 'react';
import styled from 'styled-components';
import { TextInputField } from 'src/form/components/field';

const EditWindow = () => (
  <>
    <FlexContainer>
      <TextInputField label="Titre" name="title" />
      <TextInputField label="Description" name="description" />
    </FlexContainer>
  </>
);

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 1em;
`;

export default EditWindow;
